import { useState } from 'react'
import ErpAxios from '../../api/ErpAxios';
import Loader from '../Loader';
import useAccount from '../Customer/useAccount';
const AddProperty = (props) => {
    const { account, setAccount } = useAccount();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [propertyType, setPropertyType] = useState("Villa");
    const [unitNumber, setUnitNumber] = useState("");
    const [building, setBuilding] = useState("");
    const [street, setStreet] = useState("");
    const [area, setArea] = useState("");
    const [emirate, setEmirate] = useState("Dubai");
    const [country] = useState("United Arab Emirates");
    const [isDefault, setIsDefault] = useState(true);
 const BASE_URL = '/calendar/property/add';
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(false);
        try {


             await ErpAxios.post(BASE_URL, {
                account_id: props.account.account_id,
                propertyType,
                unitNumber,
                building: propertyType !== "Villa" ? building : "",
                street,
                area,
                emirate,
                country,
                isDefault
                    })
                        .then(response => {
                            console.log(response);
            
                            if (response.data.status === true) {
                               setLoading(false);
                               setError(false);
                               const propertyId = response.data.data.property_id;
                               let address = response.data.data.address;
                                address = `${propertyType}, Unit No. ${unitNumber}${propertyType !== "Villa" && building ? ", " + building : ""}, ${street}, ${area}, ${emirate}`;
                               
                               // Update session account_details
                               let accountDetails = JSON.parse(sessionStorage.getItem("account_details"));
                               console.log('Account Details from sessionStorage:', accountDetails);
                               if (accountDetails) {
                                   accountDetails.primary_property_id = propertyId;
                                   accountDetails.primary_property_address = address;
                                   if (!accountDetails.properties) accountDetails.properties = {};
                                   accountDetails.properties[propertyId] = address;
                                   sessionStorage.setItem("account_details", JSON.stringify(accountDetails));
                               }
                               setAccount(accountDetails)
                               // Reset form fields to default
                               setPropertyType("Villa");
                               setUnitNumber("");
                               setBuilding("");
                               setStreet("");
                               setArea("");
                               setEmirate("Dubai");
                               setIsDefault(true);
                                setLoading(false);
                               setError(false);
                               props.handlePropertyChange(propertyId);

                            }else{
                              setLoading(false);
                                setError(true); 
                            }
                            
                        })
                        .catch((error) => {
                            console.log(error);
                            setLoading(false);
                            setError(true);
                        })


           
           
           
        } catch (err) {
            setError(true);
        } finally {
            setLoading(false);
        }
    };

    // ...existing code...
    return (
        <div>
              {(loading) && <div className="w-full flex justify-center mb-3"><Loader fullHeight={false} /></div>}
       
            {/* Add Property Form Section */}
            <div className="">
               
                 <div className="w-full flex justify-end mb-3">
                <button onClick={props.onClose}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="cursor-pointer"
                        width="30" height="30" viewBox="0 0 30 30" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M15 5C9.47 5 5 9.47 5 15C5 20.53 9.47 25 15 25C20.53 25 25 20.53 25 15C25 9.47 20.53 5 15 5ZM19.3 19.3C18.91 19.69 18.28 19.69 17.89 19.3L15 16.41L12.11 19.3C11.72 19.69 11.09 19.69 10.7 19.3C10.5127 19.1132 10.4075 18.8595 10.4075 18.595C10.4075 18.3305 10.5127 18.0768 10.7 17.89L13.59 15L10.7 12.11C10.5127 11.9232 10.4075 11.6695 10.4075 11.405C10.4075 11.1405 10.5127 10.8868 10.7 10.7C11.09 10.31 11.72 10.31 12.11 10.7L15 13.59L17.89 10.7C18.28 10.31 18.91 10.31 19.3 10.7C19.69 11.09 19.69 11.72 19.3 12.11L16.41 15L19.3 17.89C19.68 18.27 19.68 18.91 19.3 19.3Z" fill="#333333" />
                    </svg>
                </button>
            </div>

               <p className="md:text-2xl text-xl font-light mb-1">Add Your Address</p>

               
              

                <p className="mb-4 text-gray-600 md:text-sm text-xs font-normal">Fill in your property details to move forward.</p>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4 relative">
                        <select
                            className="w-full border-0 border-b border-gray-300 px-0 py-2 pr-8 bg-transparent focus:border-gray-500 focus:ring-0 outline-none transition appearance-none text-base"
                            value={propertyType}
                            onChange={e => setPropertyType(e.target.value)}
                            required
                        >
                            <option value="Villa">Villa</option>
                            <option value="Apartment">Apartment</option>
                            <option value="Office">Office</option>
                            <option value="Building">Building</option>
                        </select>
                        <span className="pointer-events-none absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400">
                            <svg width="20" height="20" fill="none" viewBox="0 0 20 20"><path d="M6 8l4 4 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                        </span>
                    </div>
                    <div className="mb-4">
                        <input
                            type="text"
                            className="w-full border-0 border-b border-gray-300 px-0 py-2 bg-transparent focus:border-gray-500 focus:ring-0 outline-none transition"
                            value={unitNumber}
                            onChange={e => setUnitNumber(e.target.value)}
                            required
                            placeholder={propertyType === "Villa" ? "Villa No" : propertyType === "Apartment" ? "Apt No" : propertyType === "Office" ? "Office No" : "Building No"}
                        />
                    </div>
                    {propertyType !== "Villa" && (
                        <div className="mb-4">
                            <input
                                type="text"
                                className="w-full border-0 border-b border-gray-300 px-0 py-2 bg-transparent focus:border-gray-500 focus:ring-0 outline-none transition"
                                value={building}
                                onChange={e => setBuilding(e.target.value)}
                                required
                                placeholder="Building"
                            />
                        </div>
                    )}
                    <div className="mb-4">
                        <input
                            type="text"
                            className="w-full border-0 border-b border-gray-300 px-0 py-2 bg-transparent focus:border-gray-500 focus:ring-0 outline-none transition"
                            value={street}
                            onChange={e => setStreet(e.target.value)}
                            required
                            placeholder="Street Name"
                        />
                    </div>
                    <div className="mb-4">
                        <input
                            type="text"
                            className="w-full border-0 border-b border-gray-300 px-0 py-2 bg-transparent focus:border-gray-500 focus:ring-0 outline-none transition"
                            value={area}
                            onChange={e => setArea(e.target.value)}
                            required
                            placeholder="Community / Area"
                        />
                    </div>
                    <div className="mb-4 relative">
                        <select
                            className="w-full border-0 border-b border-gray-300 px-0 py-2 pr-8 bg-transparent focus:border-gray-500 focus:ring-0 outline-none transition appearance-none text-base"
                            value={emirate}
                            onChange={e => setEmirate(e.target.value)}
                            required
                        >
                            <option value="Abu Dhabi">Abu Dhabi</option>
                            <option value="Dubai">Dubai</option>
                            <option value="Sharjah">Sharjah</option>
                            <option value="Ajman">Ajman</option>
                            <option value="Umm Al Quwain">Umm Al Quwain</option>
                            <option value="Ras Al Khaimah">Ras Al Khaimah</option>
                            <option value="Fujairah">Fujairah</option>
                        </select>
                        <span className="pointer-events-none absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400">
                            <svg width="20" height="20" fill="none" viewBox="0 0 20 20"><path d="M6 8l4 4 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                        </span>
                    </div>
                    {/* Country field removed as requested */}
                    <div className="mb-6 flex items-center">
                        <label htmlFor="defaultAddress" className="flex items-center cursor-pointer">
                            <span className="relative mr-2">
                                <input type="checkbox" id="defaultAddress" checked={isDefault} onChange={e => setIsDefault(e.target.checked)} className="sr-only" />
                                <span className={`block w-5 h-5 rounded bg-red-100 border border-red-300 ${isDefault ? 'bg-red-400 border-red-400' : ''}`}></span>
                                {isDefault && (
                                    <svg className="absolute left-0 top-0 w-5 h-5 text-white" viewBox="0 0 20 20" fill="none">
                                        <path d="M5 10l3 3 7-7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                )}
                            </span>
                            <span className="text-sm">Set as Default Address</span>
                        </label>
                    </div>
                    {error && <div className="text-red-500 mb-2">Failed to add property. Please try again.</div>}
                    <button type="submit" className="w-full bg-red-500 text-white py-3 rounded-lg text-lg font-semibold shadow-sm hover:bg-red-600 transition" disabled={loading}>
                        {loading ? "Submitting..." : "Continue"}
                    </button>
                </form>
            </div>
            {/* ...existing booking code below... */}
            {/* Place your existing booking JSX here, below the form section */}
            {/* ...existing code... */}
        </div>
    );
   
}
export default AddProperty;